import React from 'react';

function TermsOfService() {
  return (
    <div className="page-terms" style={{ padding: '4rem 1.5rem', maxWidth: '900px', margin: '0 auto' }}>

      {/* Header section */}
      <header style={{ marginBottom: '3rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
        <span className="section-tag" style={{ textTransform: 'uppercase', color: 'var(--accent-color)', fontWeight: 700, fontSize: '0.85rem', letterSpacing: '1.5px' }}>
          Compliance & Legal
        </span>
        <h1 style={{ fontFamily: 'var(--font-title)', fontSize: '2.5rem', fontWeight: 900, textTransform: 'uppercase', color: 'var(--text-primary)', marginTop: '0.5rem', marginBottom: '1rem' }}>
          Terms of Service
        </h1>
        <p style={{ color: 'var(--text-secondary)', fontSize: '0.95rem' }}>
          Last Updated: January 01, 2026 | Saveera Biotech Guidelines
        </p>
      </header>

      {/* Content body */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', textAlign: 'left', lineHeight: '1.7', color: 'var(--text-secondary)' }}>

        <section>
          <h3 style={{ fontFamily: 'var(--font-title)', color: 'var(--text-primary)', fontSize: '1.3rem', textTransform: 'uppercase', marginBottom: '0.8rem', fontWeight: 800 }}>
            1. Acceptance of Terms
          </h3>
          <p>
            By accessing or using the website and professional consulting services offered by Saveera Biotech, you agree to be bound by these Terms of Service. If you do not agree to these terms, please discontinue your use of our website immediately.
          </p>
        </section>

        <section>
          <h3 style={{ fontFamily: 'var(--font-title)', color: 'var(--text-primary)', fontSize: '1.3rem', textTransform: 'uppercase', marginBottom: '0.8rem', fontWeight: 800 }}>
            2. Scope of Services
          </h3>
          <p>
            Saveera Biotech provides digital marketing campaigns, IT consultancy, computer programming, and software advisory services. All project proposals, milestones, and deliverables are subject to individual Statement of Work (SOW) agreements signed by authorized corporate representatives.
          </p>
        </section>

        <section>
          <h3 style={{ fontFamily: 'var(--font-title)', color: 'var(--text-primary)', fontSize: '1.3rem', textTransform: 'uppercase', marginBottom: '0.8rem', fontWeight: 800 }}>
            3. User Conduct & Responsibilities
          </h3>
          <p>
            When submitting inquiries, requests for consultation, or using our platform, you agree:
          </p>
          <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem', listStyleType: 'square' }}>
            <li>To provide true, accurate, and current corporate details</li>
            <li>Not to submit malicious software codes, spam, or unlawful communications</li>
            <li>Not to attempt unauthorized access to our private engineering networks or databases</li>
          </ul>
        </section>

        <section>
          <h3 style={{ fontFamily: 'var(--font-title)', color: 'var(--text-primary)', fontSize: '1.3rem', textTransform: 'uppercase', marginBottom: '0.8rem', fontWeight: 800 }}>
            4. Intellectual Property
          </h3>
          <p>
            All custom graphics, website source code layouts, texts, and logo icons displayed on this website are the proprietary property of Saveera Biotech. No content may be reproduced, distributed, or mirrored without prior written consent from our corporate office.
          </p>
        </section>

        <section>
          <h3 style={{ fontFamily: 'var(--font-title)', color: 'var(--text-primary)', fontSize: '1.3rem', textTransform: 'uppercase', marginBottom: '0.8rem', fontWeight: 800 }}>
            5. Limitation of Liability
          </h3>
          <p>
            Saveera Biotech provides consulting opinions on an "as-is" advisory basis. In no event shall we be liable for indirect, accidental, or consequential business losses (including loss of profits, system downtime, or data corruption) arising out of your use of our standard website resources.
          </p>
        </section>

        <section style={{ borderTop: '1px solid var(--border-color)', paddingTop: '2rem', marginTop: '1rem' }}>
          <h3 style={{ fontFamily: 'var(--font-title)', color: 'var(--text-primary)', fontSize: '1.3rem', textTransform: 'uppercase', marginBottom: '0.8rem', fontWeight: 800 }}>
            Legal Inquiries
          </h3>
          <p>
            For questions regarding our service parameters, licensing compliance, or corporate liabilities, please contact:
          </p>
          <p style={{ marginTop: '0.5rem', fontWeight: 700, color: 'var(--text-primary)' }}>
            Email: <a href="mailto:info@saveerabiotech.com" style={{ color: 'var(--accent-color)', textDecoration: 'none' }}>info@saveerabiotech.com</a>
          </p>
        </section>

      </div>

    </div>
  );
}

export default TermsOfService;
